import Vue from 'vue';
import { AclInstaller, AclCreate, AclRule } from 'vue-acl';
import router from './router';

Vue.use(AclInstaller);
const startRole = localStorage.getItem('caregiver:role') ? localStorage.getItem('caregiver:role') : 'public';

export default new AclCreate({
  initial: startRole,
  notfound: {
    path: '/login',
    forwardQueryParams: false,
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    isPublic: new AclRule('public').or('caregiver').generate(),
    isLogged: new AclRule('caregiver').generate(),
  },
  middleware: async () => {
    // console.log('middleware');
    // acl.change('admin');
  },
});
